import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import CancelPay from "./Component/CancelPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import Cookies from "./Component/Cookies";
import Faqs from "./Component/Faqs";
import Policies from "./Component/Policies";
import PolicyPage from "./Component/PolicyPage";
import { policies } from "./Datas/policyData";

const additionalPolicyRoutes = [
  ["/terms-of-sale", policies.sale],
  ["/refunds", policies.refunds],
  ["/cancellations", policies.cancellations],
  ["/payments", policies.payments],
  ["/pricing", policies.pricing],
  ["/international-orders", policies.internationalOrders],
  ["/warranties", policies.warranties],
  ["/complaints", policies.complaints],
  ["/data-rights", policies.dataRights],
  ["/security", policies.security],
  ["/marketing", policies.marketing],
  ["/accessibility", policies.accessibility],
  ["/acceptable-use", policies.acceptableUse],
  ["/intellectual-property", policies.intellectualProperty],
  ["/user-content", policies.userContent],
  ["/product-safety", policies.productSafety],
  ["/recalls", policies.recalls],
  ["/age-restricted-products", policies.ageRestricted],
  ["/promotions", policies.promotions],
  ["/gift-cards", policies.giftCards],
  ["/subscriptions", policies.subscriptions],
  ["/ethical-trading", policies.ethicalTrading],
  ["/modern-slavery", policies.modernSlavery],
  ["/sustainability", policies.sustainability],
  ["/anti-bribery", policies.antiBribery],
];

function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/policies" element={<Policies />} />
          {additionalPolicyRoutes.map(([path, policy]) => (
            <Route key={path} path={path} element={<PolicyPage policy={policy} />} />
          ))}
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
          <Route path="/success_url" element={<PaySuccess />} />
          <Route path="/cancel_url" element={<CancelPay />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
